import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { SingleButtonModal } from '../../components/SingleButtonModal/SingleButtonModal';
import { ESHOP_TEST_ID } from '../../test/test-ids';
import { useVasModalControls } from './useVasModalControls';

export const VasModal: FC = () => {
    const { t } = useTranslations();
    const { modalData, closeModal, isModalOpen } = useVasModalControls();

    return (
        <SingleButtonModal
            title={modalData?.title}
            btnText={t['eshop.product_page.vas.modal.close_btn']}
            cmsContent={modalData?.description}
            onHide={closeModal}
            isShown={isModalOpen}
            dataTest={ESHOP_TEST_ID.VAS_MODAL}
        />
    );
};
